var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.27178 1.71127L4.56178 5.95127C4.65474 6.045 4.76534 6.11939 4.8872 6.17016C5.00906 6.22093 5.13977 6.24707 5.27178 6.24707C5.40379 6.24707 5.5345 6.22093 5.65636 6.17016C5.77822 6.11939 5.88882 6.045 5.98178 5.95127L10.2218 1.71127C10.3155 1.61831 10.3899 1.50771 10.4407 1.38585C10.4914 1.26399 10.5176 1.13328 10.5176 1.00127C10.5176 0.86926 10.4914 0.738555 10.4407 0.616695C10.3899 0.494836 10.3155 0.384235 10.2218 0.291272C10.0344 0.105021 9.78097 0.000479634 9.51678 0.000479611C9.25259 0.000479588 8.99914 0.105021 8.81178 0.291272L5.27178 3.83127L1.73178 0.291271C1.54552 0.106527 1.29412 0.00237602 1.03178 0.00127137C0.900174 0.000510468 0.769711 0.025735 0.647873 0.0754996C0.526036 0.125264 0.41522 0.19859 0.32178 0.291271C0.224705 0.380889 0.146351 0.488855 0.0912442 0.608931C0.0361375 0.729006 0.00537058 0.858811 0.000721437 0.990847C-0.0039277 1.12288 0.0176332 1.25453 0.0641579 1.37818C0.110683 1.50184 0.181249 1.61505 0.27178 1.71127Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.b6889f2598728cdf175371d3397addc4.svg";
export { ForwardRef as ReactComponent };